/**
 * Les deux sociétés Alertis, vues des documents du formateur.
 * Partagé entre le serveur et le front — single source of truth.
 *
 * Alertis est deux sociétés immatriculées séparément. Le formateur signe une
 * charte et un contrat annuel de sous-traitance avec CHACUNE : quatre pièces,
 * et non deux.
 *
 * ATTENTION AUX CLÉS. 'ALERTIS_1' et 'ALERTIS_2' sont une convention interne
 * héritée de la règle fiscale des devis — ALERTIS_1 est l'entité assujettie à
 * la TVA — et NON l'ordre dans lequel l'équipe parle des deux sociétés. Elles
 * ne s'affichent jamais telles quelles : partout où un humain lit, on écrit la
 * raison sociale.
 */

import { ALERTIS_1_COMPANY_NAME, ALERTIS_2_COMPANY_NAME } from './alertis-constants.js';

/**
 * Les deux sociétés, dans l'ordre d'affichage : la plus ancienne d'abord.
 * `cle` est la clé technique, `nom` la raison sociale du registre, `nomCourt`
 * ce qu'on écrit dans un titre d'encart ou un bouton, `fichier` le mot qui
 * distingue les deux PDF dans un dossier de téléchargements.
 */
export const SOCIETES_FORMATEUR = [
  {
    cle: 'ALERTIS_2',
    nom: ALERTIS_1_COMPANY_NAME,
    nomCourt: 'Alertis Centre de formation',
    fichier: 'centre-de-formation',
  },
  {
    cle: 'ALERTIS_1',
    nom: ALERTIS_2_COMPANY_NAME,
    nomCourt: 'Alertis Formation incendie',
    fichier: 'formation-incendie',
  },
];

/** Les clés seules, dans l'ordre d'affichage. */
export const ENTITES_FORMATEUR = SOCIETES_FORMATEUR.map((s) => s.cle);

/**
 * La société dont les documents alimentent les colonnes `charte*` et
 * `contratCadre*` de `formateurs`.
 *
 * C'est 'ALERTIS_1' parce que c'est sous cette clé que tout a été émis jusqu'au
 * 21/09/2026 : le miroir continue de décrire le même document qu'avant, et
 * aucune des vingt lectures qui l'interrogent ne change de réponse du jour au
 * lendemain.
 */
export const ENTITE_REFERENCE = 'ALERTIS_1';

/** @param {string} entite */
function societe(entite) {
  return SOCIETES_FORMATEUR.find((s) => s.cle === entite);
}

/**
 * La raison sociale complète, pour un document ou une mention légale.
 * @param {string} entite
 * @returns {string}
 */
export function nomSociete(entite) {
  return societe(entite)?.nom || entite;
}

/**
 * Le nom court, quand la raison sociale complète noierait la phrase.
 * @param {string} entite
 * @returns {string}
 */
export function nomCourtSociete(entite) {
  return societe(entite)?.nomCourt || entite;
}

/**
 * Le mot qui distingue les fichiers des deux sociétés.
 * @param {string} entite
 * @returns {string}
 */
export function suffixeFichier(entite) {
  return societe(entite)?.fichier || 'alertis';
}
